import { render, staticRenderFns } from "./ShowDialogProblema.vue?vue&type=template&id=19209cf2&scoped=true"
import script from "./ShowDialogProblema.vue?vue&type=script&lang=js"
export * from "./ShowDialogProblema.vue?vue&type=script&lang=js"
import style0 from "./ShowDialogProblema.vue?vue&type=style&index=0&id=19209cf2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19209cf2",
  null
  
)

export default component.exports